<script>
export default {
  props: {
    title: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    compact: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    icon: { type: String, default: '' },
  },
};
</script>

<template>
  <div
    v-if="inline"
    class="flex items-center justify-between gap-2 px-3 py-2.5 overflow-auto"
  >
    <div class="flex items-center flex-shrink-0 min-w-0 gap-2.5">
      <span
        v-if="icon"
        class="flex-shrink-0 size-4 text-n-slate-11"
        :class="icon"
      />
      <span class="text-sm truncate text-n-slate-12">
        {{ title }}
      </span>
    </div>
    <div class="flex items-center justify-end min-w-0 gap-1">
      <slot name="button" />
      <div v-if="value" class="text-sm break-words truncate text-n-slate-11">
        <slot>
          {{ value }}
        </slot>
      </div>
    </div>
  </div>
  <div
    v-else
    class="overflow-auto"
    :class="compact ? 'py-0 px-0' : 'py-3 px-4'"
  >
    <div class="items-center flex justify-between mb-1.5">
      <span class="text-sm font-medium text-n-slate-12">
        {{ title }}
      </span>
      <slot name="button" />
    </div>
    <div v-if="value" class="break-words">
      <slot>
        {{ value }}
      </slot>
    </div>
  </div>
</template>
